module.exports = __webpack_public_path__ + "img/ambank-img.047bfb14.png";